<template>
	<div class="flex flex-col gap-0.5">
		<div class="meta-label">{{ metaLabel }}</div>
		<div class="meta-primary flex items-center gap-1.5 font-medium">
			<!-- Strikethrough original price if present -->
			<span v-if="originalPrice" class="text-gray-600 line-through">
				{{ originalPrice }}
			</span>
			<span>{{ metaPrimary }}</span>
		</div>
		<div v-if="metaSecondary" class="meta-secondary">
			{{ metaSecondary }}
		</div>
	</div>
</template>

<script setup lang="ts">
interface Props {
	metaLabel: string
	metaPrimary: string | null
	originalPrice?: string | null
	metaSecondary?: string | null
}

defineProps<Props>()
</script>
